var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticStyle:{"width":"100%"},attrs:{"color":"purple","dark":""},on:{"click":function($event){return _vm.AddStoreArticles(_vm.Articles)}}},[_vm._v("Publish Items")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }